import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import visa from "../../../assets/images/visa.png";
import mastercard from "../../../assets/images/master-card.png";
import eftops from "../../../assets/images/eftops.png";
import InputSelector from "../../inputselector/InputSelector";
const GuideBanner = ({ content, heading, cardContent }) => {
  return (
    <>
      <section
      style={{
        backgroundImage: `url('https://keyzi.com.au/keyzi-admin/public${cardContent?.[0]?.image}')`,
      }}
        className={`keyzi_clickAway--wrapper click_away--banner`}
      >
    
        <Container>
          <div className="keyzi_clickAway--inner"  >
            <Row>
              <Col lg={6}></Col>
              <Col lg={6}>
                <div className="newPage--InputSelector newPage_ahead-inputSelector">
                  <h3>
                    {}
                    {heading
                      ? heading
                      : !content
                      ? "Choose us to guide you or your teenager to driving success!"
                      : content}
                  </h3>
                  <InputSelector label="Instructor Search" />
                  <div className="fp_weaccept">
                    <h4>We Accept</h4>
                    <img src={visa} className="img-fluid " alt="Visa" />
                    <img
                      src={mastercard}
                      className="img-fluid master_card"
                      alt="Master Card"
                    />
                    <img src={eftops} className="img-fluid " alt="Eftops" />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default GuideBanner;
